import { MinzeElement, Reactive, EventListeners, Attrs } from 'minze'
import { MODALS } from '../../../constants'
import MainModule from '../../../modules/main'
import {
  AbstractSubscriber,
  AbstractSearchCore,
  IFacet,
  IFacetOption,
  ISearchConfig,
} from '../../../modules/search'
import { Locale } from '../../../modules/locale'
import { Font } from '../../../constants'
import { Callback } from '../../../modules/callback'

Locale.getInstance().registerKeySet('fr', 'freeShowFilter', {
  label: 'Afficher seulement les événements gratuits',
})

Locale.getInstance().registerKeySet('en', 'freeShowFilter', {
  label: 'Show only free events',
})

class LvcFreeShowSubscriber extends AbstractSubscriber {
  private _core: AbstractSearchCore | null = null
  private _callback: (...args: any[]) => void

  constructor(groupId: string, callback: (...args: any[]) => void) {
    super(groupId)
    this._callback = callback
  }

  public async attached(core: AbstractSearchCore): Promise<void> {
    this._core = core
  }

  public detaching(): void {
    this._core = null
  }

  async onSearchTextUpdate(text: string): Promise<void> {}
  async onResultUpdate(results: any): Promise<void> {}
  async onFacetUpdate(facets: IFacet[]): Promise<void> {}

  async onSearchConfigUpdate(config: ISearchConfig): Promise<void> {
    let audienceFacet = config?.facets?.find(facet => facet.name === 'isAccessibleForFree')

    if (audienceFacet) {
      let freeOption = audienceFacet.options?.find(option => option.value === 'true')

      if (freeOption) {
        this._callback(freeOption.selected)
        return
      }
    }

    this._callback(false)
  }

  public async toggleFreeOnly(toggle: boolean): Promise<void> {
    let searchConfig = this._core?.searchConfig
    if (!searchConfig) {
      searchConfig = {} as ISearchConfig
    }
    let audienceFacet = searchConfig?.facets?.find(facet => facet.name === 'isAccessibleForFree')

    if (!audienceFacet) {
      audienceFacet = {
        name: 'isAccessibleForFree',
        options: [],
      }
      searchConfig.facets?.push(audienceFacet)
    }

    let freeOption = audienceFacet.options?.find(option => option.value === 'true')

    if (!freeOption) {
      freeOption = {
        value: 'true',
        selected: false,
      } as IFacetOption
      audienceFacet.options?.push(freeOption)
    }

    freeOption.selected = toggle
    searchConfig.page = 0
    const resetToFirstPage = (obj: { [key: string]: number }): { [key: string]: number } => {
      for (let key in obj) obj[key] = 0
      return obj
    }
    if (searchConfig.options) {
      searchConfig.options.page = resetToFirstPage(searchConfig.options?.page)
    }
    this._core?.applySearchConfig(searchConfig)
    this._core?.goToSearch(false)
  }
}

export class LvcFreeSearch extends MinzeElement {
  private toggleCb: string = Callback.attach(this.onToggle.bind(this))
  private initialToggled: boolean = true
  private subscriber: LvcFreeShowSubscriber | null = null

  async onReady(): Promise<void> {
    this.subscriber = new LvcFreeShowSubscriber(
      this.dataGroupId as string,
      this.searchUpdated.bind(this)
    )
    MainModule.getInstance().getSearchManager().subscribe(this.subscriber)
    this.rerender()
  }

  async searchUpdated(toggle: boolean): Promise<void> {
    this.initialToggled = toggle
    this.rerender()
  }

  async onToggle(tgl: boolean): Promise<void> {
    this.toggled = tgl
    this.subscriber?.toggleFreeOnly(tgl)

    this.rerender()
  }

  onDestroy() {
    Callback.detach(this.toggleCb)
  }

  html = () => `
      <lvc-toggle initial-toggled="${this.initialToggled ? 'true' : 'false'}" on-click="${this.toggleCb}"></lvc-toggle>
      <span class="label">${Locale.getKey('freeShowFilter.label')}</span>
  `

  css = () => `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 14px;
    }
  `
}
